import { getField, updateField } from "vuex-map-fields";
import { checklistService } from "../services";
import { EventBus } from "@/helpers";

export const checklist = {
  namespaced: true,
  state: {
    checklists: []
  },
  actions: {
    getChecklists(context) {
      return checklistService
        .getChecklists()
        .then(response => {
          console.log(response);
          context.commit("setChecklists", {
            response
          });
        })
        .catch(error => {
          console.log("Error getChecklists: ", error);
          EventBus.$emit("failedGetChecklists", error);
        });
    },
    restore(context, payload) {
      return checklistService
        .restore(payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedRestoreChecklist", response.error);
          } else {
            context.dispatch("getChecklists");
          }
        })
        .catch(error => {
          console.log("Error restoreChecklist: ", error);
          EventBus.$emit("failedRestoreChecklist", error);
        });
    },
    add(context, payload) {
      return checklistService
        .addChecklist(payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedAddChecklist", response.error);
          } else {
            context.dispatch("getChecklists");
          }
        })
        .catch(error => {
          console.log("Error addChecklist: ", error);
          EventBus.$emit("failedAddChecklist", error);
        });
    },
    edit(context, payload) {
      return checklistService
        .editChecklist(payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedEditChecklist", response.error);
          } else {
            context.dispatch("getChecklists");
          }
        })
        .catch(error => {
          console.log("Error editChecklist: ", error);
          EventBus.$emit("failedEditChecklist", error);
        });
    },
    delete(context, payload) {
      return checklistService
        .deleteChecklist(payload)
        .then(response => {
          console.log(response);
          if (response.error) {
            EventBus.$emit("failedDeleteChecklist", response.error);
          } else {
            context.dispatch("getChecklists");
          }
        })
        .catch(error => {
          console.log("Error deleteChecklist: ", error);
          EventBus.$emit("failedDeleteChecklist", error);
        });
    }
  },
  mutations: {
    updateField,
    setChecklists(state, payload) {
      if (payload) {
        state.checklists = JSON.parse(payload.response.data);
      } else {
        state.checklists = [];
      }
      state.checklists.push({ sections: [] });
      EventBus.$emit("setChecklists");
    }
  },
  getters: {
    getField
  }
};
